import { apiClient } from './apiClient';
import { normalizePlansResponse } from './normalizers';

const base = '/api/plans';

export const plansService = {
  list: () => apiClient.get(base).then(normalizePlansResponse),
};

export default plansService;
